import React from 'react'
import {
  IonSkeletonText
} from '@ionic/react'
import './styles.scss'

const RssChapterCardSkeleton = () => {
  return (
    <div
      className='rss-chapter-card-skeleton'
    >

      <section className='identify'>
        <figure>
          <IonSkeletonText className='image' animated />
        </figure>
        <figcaption>
          <IonSkeletonText className='title' animated />
        </figcaption>
      </section>

      <section
        className='intro-container'
      >
        <IonSkeletonText className='text' animated />
        <IonSkeletonText className='text' animated />
        <IonSkeletonText className='text' animated />
        <IonSkeletonText className='text' animated />
        <IonSkeletonText className='text' animated />
      </section>

      <section className='controls'>
        <IonSkeletonText className='play-button' animated />
      </section>
    </div>
  )
}

export default RssChapterCardSkeleton
